import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-address_del",
  "use": "icon-address_del-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-address_del\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M4.667 2.667V1.333h6.666v1.334h3.334V4h-1.334v10a.667.667 0 0 1-.666.667H3.333A.667.667 0 0 1 2.667 14V4H1.333V2.667h3.334ZM4 4v9.333h8V4H4Zm2 2h1.333v5.333H6V6Zm2.667 0H10v5.333H8.667V6Z\" fill=\"#ED4F4F\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol